import {Observable} from "rxjs";
import {Door} from "../../models/door";
import {GenericFilter} from "../filter/filter.service";
import {PaginationMode} from "../../../generated/graphql";
import {CursorBasedPaginationInfo, PaginationInfo} from "./graphql.door.loader";
import {Product} from "../../models/product";

export abstract class DoorLoader {
  abstract getDoors(customerKey: string, filter?: GenericFilter): Observable<Array<Product>>

  abstract getDoorsPaginated(customerKey: string, filter: GenericFilter, paginationArgs: {page?: number, afterCursor?: string, mode: PaginationMode }):
    Observable<
      {
        paginationMode: PaginationMode,
        cursorBasedPaginationInfo?: CursorBasedPaginationInfo,
        paginationInfo?: PaginationInfo,
        result: Array<Product>
      }>;

  abstract getDoor(customerKey: string, externalDoorId: string): Observable<Product>
}
